
//URL
import axios from "axios";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { alertService } from "components/Varios/alert_service";
import { authenticationService } from "services/authentication.service";
import configData from "../config.json";

export async function downloadExcelReport(apiexcel: string, nombreArchivo?: string, numberYear: number = 0) {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }
    var anio_para_nombre = ""
    if (numberYear > 0) {
        apiexcel += `/${numberYear}`
        anio_para_nombre = numberYear.toString()
    }
    await fetch(configData.SERVER_URL + `${apiexcel}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser?.token}`
        },
    })
        .then(response => {
            response.blob().then(blob => {

                if (blob.size > 0) {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    if(nombreArchivo && anio_para_nombre !==""){
                        a.download = nombreArchivo + " " + anio_para_nombre;
                    }
                    else if(nombreArchivo === undefined && anio_para_nombre !==""){
                        a.download = "Reporte" + " " + anio_para_nombre
                    }
                    else if(nombreArchivo && anio_para_nombre === "") {
                        a.download = nombreArchivo
                    }
                    a.click();
                }
                else{
                    alertService.error("Ha ocurrido un inconveniente con la descarga del archivo.");
                    window.scrollTo(0, 0);
                }



            });
        })
        .catch((error) => {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            switch (status_code) {
                case 0 || -1:
                    alertService.error("No se ha podido establecer contacto con el servidor");
                    break;
                case 500:
                    alertService.error("Ha ocurrido un error inesperado");
                    break;
                default:
                    alertService.error("Ha ocurrido un error desconocido");
                    break;
            }

            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
            return -1
        });
    return 1



}

export async function downloadExcelReportNoYear(apiexcel: string, nombreArchivo?: string) {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }
    await fetch(configData.SERVER_URL + `${apiexcel}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser?.token}`
        },
    })
        .then(response => {
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = nombreArchivo ?? "Reporte.xlsx" //nombrearchivo
                a.click();
                return 1
            });
        })
        .catch((error) => {
            if (axios.isAxiosError(error) && error.response) {
                const status_code = error.response.status;

                switch (status_code) {
                    case 0 || -1:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }

                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            }
            return -1
        });

}

function getHeaderObject(tokenUser: string) {
    var resultado = {
        'Content-Type': 'application/json',
        Authorization: `KEYESPOL ${tokenUser}`
    };
    return resultado;
}

const auxiliar_catch_error = (error, infoadicional?: string) => {
    var error_any: any = error;
    var status_code: number = handle_error(error_any);
    switch (status_code) {
        case 0 || -1:
            alertService.error("No se ha podido establecer contacto con el servidor" + infoadicional);
            break;
        case 500:
            alertService.error("Ha ocurrido un error inesperado" + infoadicional);
            break;
        default:
            alertService.error("Ha ocurrido un error desconocido" + infoadicional);
            break;
    }

    window.scrollTo({
        top: 0,
        behavior: "auto"
    });
    return -1
}

export async function GetYearsFromApi(api: string) {
    var year_response: number[] = [];
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return year_response }
    try {
        const respuesta = await axios.get(configData.SERVER_URL + api,
            {
                headers: getHeaderObject(currentUser.token)
            })

        year_response = respuesta.data;

    } catch (error) {
        var status = auxiliar_catch_error(error, " al tratar de obtener los años para descargar el reporte")

    }
    return year_response
}